var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#E42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3529 10.5696C19.4135 10.5091 19.4616 10.4373 19.4944 10.3582C19.5272 10.2791 19.5441 10.1944 19.5442 10.1087C19.5442 10.0231 19.5274 9.93834 19.4947 9.85923C19.462 9.78011 19.414 9.70821 19.3535 9.64764C19.293 9.58706 19.2212 9.539 19.1421 9.50619C19.063 9.47338 18.9782 9.45646 18.8926 9.45641C18.807 9.45636 18.7222 9.47317 18.6431 9.50588C18.564 9.5386 18.4921 9.58657 18.4315 9.64707L14.5 13.5786L10.5696 9.64707C10.4473 9.52474 10.2813 9.45601 10.1083 9.45601C9.93532 9.45601 9.7694 9.52474 9.64706 9.64707C9.52473 9.76941 9.456 9.93533 9.456 10.1083C9.456 10.2813 9.52473 10.4473 9.64706 10.5696L13.5786 14.5L9.64706 18.4304C9.58649 18.491 9.53844 18.5629 9.50566 18.642C9.47287 18.7212 9.456 18.806 9.456 18.8917C9.456 18.9773 9.47287 19.0622 9.50566 19.1413C9.53844 19.2205 9.58649 19.2924 9.64706 19.3529C9.7694 19.4753 9.93532 19.544 10.1083 19.544C10.194 19.544 10.2788 19.5271 10.358 19.4943C10.4371 19.4616 10.509 19.4135 10.5696 19.3529L14.5 15.4214L18.4315 19.3529C18.5539 19.4751 18.7197 19.5437 18.8926 19.5436C19.0655 19.5435 19.2313 19.4747 19.3535 19.3524C19.4757 19.23 19.5443 19.0642 19.5442 18.8913C19.5441 18.7184 19.4753 18.5526 19.3529 18.4304L15.4214 14.5L19.3529 10.5696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.b18b274f40c11f81eb47d1736853b922.svg";
export { ForwardRef as ReactComponent };